import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  Stats,
  SpacerV,
} from "../components/Hero";
import { API_URL } from "../actions/auth";
import axios from "axios";
import { useNavigate } from "react-router";
import { TypeAnimation } from "react-type-animation";
import Lottie from "react-lottie";
import {
  OurProcess,
  Advantages,
  YouWillGet,
  Collage,
  FAQ2,
  Collage2,
  Trust,
  Tailor,
} from "../components/Sections";
import { layout } from "../components/Layout";

export default function ContentMarketing() {
  const [news, setNews] = useState([]);
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const dark = true;

  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div
          className="anigrad"
          style={{ backgroundColor: dark ? "#111" : "white" }}
        >
          <div
            style={{
              height: state.auth.isMobile ? "130vh" : "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                width: "75vw",
              }}
            >
              <div
                style={{
                  marginTop: state.auth.isMobile
                    ? state.auth.isTablet
                      ? "-300px"
                      : "-135px"
                    : "0px",
                  fontSize: state.auth.isMobile ? "25px" : "6vh",
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                  marginBottom: "25px",
                  fontWeight: "bold",
                }}
              >
                <div
                  style={{
                    fontSize: layout.heading2[state.auth.view],
                  }}
                >
                  Build Brand Authority with a Leading Content Marketing Agency
                </div>
              </div>

              <div
                style={{
                  fontSize: layout.textMedium[state.auth.view],
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                }}
              >
                We build content that drives engagement and converts audiences
                into loyal customers. Our data-backed approach creates valuable
                resources that establish industry credibility and attract
                high-intent users.{" "}
                {!state.auth.isMobile
                  ? "We develop structured content strategies that support business growth and improve organic reach."
                  : ""}
              </div>
              <button
                style={{
                  marginTop: "6vh",
                  filter: dark ? "invert(0)" : "invert(1)",
                }}
                onClick={() => {
                  navigate("/get-a-quote/");
                }}
                className="squishy"
              >
                Request a free estimate
              </button>
              <div
                style={{
                  display:
                    state.auth.isMobile || state.auth.view == "TABP"
                      ? "none"
                      : "block",
                }}
              >
                <Tailor
                  invert
                  title1="Crafted for You"
                  subtitle1="Uniquely designed to reflect your brand’s story."
                  title2="Focused on Growth"
                  subtitle2="Strategically built to help your business thrive."
                  title3="Effortless Experience"
                  subtitle3="Seamlessly create, update, and manage content."
                />
              </div>
            </div>
          </div>
          <Stats />
          {state.auth.isTablet ? (
            <SpacerV height={"300px"} background="#111" />
          ) : (
            ""
          )}
          <ContentSideBySide
            dark={dark}
            title={
              <h2>
                Content Marketing for Higher Visibility and Better Engagement
              </h2>
            }
            subtitle={
              <div>
                At Riches Media Digital, we execute content marketing strategies
                that create impact. Our team develops compelling narratives and
                distributes them across relevant channels. We make sure that
                every piece of content attracts the right audience and drives
                measurable business outcomes. Our structured content plans
                improve engagement and strengthen brand positioning.
              </div>
            }
            image={
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: require("../img/marketing (11).json"),
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
                height={state.auth.isMobile ? 350 : 500}
                width={state.auth.isMobile ? 350 : 500}
                isStopped={false}
                isPaused={false}
              />
            }
          />
          <SpacerV height={"100px"} background={dark ? "#111" : "white"} />
          <OurProcess
            process={"Our Content Marketing Process"}
            invert={!dark}
            step1={"Audience Research and Content Strategy Development"}
            step1description={
              "We analyze customer behavior and identify key interests. Our team maps content to audience needs and business goals. We also refine messaging to increase relevance and engagement."
            }
            step2={"High-Value Content Creation and Optimization"}
            step2description={
              "We develop in-depth blog posts and authoritative resources. Our team optimizes each piece for search intent. We also refine structure and readability to improve content effectiveness."
            }
            step3={"Content Distribution and Multi-Channel Promotion"}
            step3description={
              "We distribute content through organic and <a href='https://richesmediadigital.com/pay-per-click/'>paid channels</a>. Our team maximizes reach by leveraging high-impact platforms. We also refine content placement strategies to increase <a href='https://richesmediadigital.com/blog/social-media-marketing-hacks-to-double-your-brand-engagement/'>audience engagement</a>."
            }
            step4={"Performance Tracking and Data-Driven Refinement"}
            step4description={
              "We analyze content performance and track key engagement metrics. Our team refines strategies based on user interaction. We also optimize underperforming content to improve visibility."
            }
          />
          <Advantages
            invert={!dark}
            title={"Advantages of Content Marketing Service For Businessness"}
            title1={"Stronger Brand Presence"}
            subtitle1={
              "We develop content that establishes credibility and strengthens authority. A structured approach increases audience trust and brand recognition."
            }
            title2={
              "Higher <a href='https://richesmediadigital.com/blog/social-media-marketing-hacks-to-double-your-brand-engagement/'>audience engagement</a>"
            }
            subtitle2={
              "We create content that resonates with the target audience and improves interaction. A value-driven strategy increases time spent on site and social media engagement."
            }
            title3={"SEO-Optimized Content"}
            subtitle3={
              "We optimize content to attract organic traffic and increase discoverability. A data-backed approach improves keyword rankings and content reach."
            }
            title4={"Improved Lead Generation"}
            subtitle4={
              "We develop conversion-focused content that attracts high-intent users. Targeted strategies improve lead quality and drive better business outcomes."
            }
          />
          <ContentSideBySideInv
            dark={dark}
            title={<h2>Fuel Business Growth with High-Intent Content</h2>}
            subtitle="At Riches Media Digital, we develop content marketing strategies that turn passive audiences into active customers. Our team structures messaging to match search intent and business goals. We refine storytelling to increase engagement. This makes sure that every content asset contributes to higher visibility and improved customer acquisition. We create thought leadership articles and conversion-driven landing pages. Our content strategy drives measurable growth and improves <a href='https://richesmediadigital.com/blog/social-media-marketing-hacks-to-double-your-brand-engagement/'>audience engagement</a>."
            image={
              <img
                style={{ width: "100%", borderRadius: "25px" }}
                src={require("../img/about-banner.png")}
              />
            }
          />
          <SpacerV height={"100px"} background={dark ? "#111" : "white"} />
          <YouWillGet
            willget={"What Content Marketing Services Will You Get"}
            invert={!dark}
            title1={"Strategic Content Planning"}
            title2={"Audience-Centric Messaging"}
            title3={"SEO-Optimized Content Development"}
            title4={"Multi-Channel Distribution Experts"}
            title5={"Conversion-Focused Storytelling"}
          />
          <div
            style={{
              display:
                state.auth.isMobile || state.auth.view == "TABP"
                  ? "none"
                  : "block",
            }}
          >
            <Trust invert />
          </div>
          <FAQ2
            invert={!dark}
            q1="What is content marketing?"
            a1="Content marketing develops and distributes valuable content to attract and engage audiences. It involves blog writing and in-depth resources. It further encircles structured storytelling to improve customer acquisition."
            q2="Why is content marketing important for my business?"
            a2="Content marketing increases brand authority and builds long-term relationships with customers. It improves organic reach and strengthens audience trust. Businesses that invest in content marketing generate more leads and improve conversion rates."
            q3="How long does it take to see results?"
            a3="Content marketing delivers sustained growth over time. Businesses typically see engagement improvements within three to six months based on distribution and audience targeting. Consistent publishing and content refinement improve long-term results."
            q4="What types of content perform best?"
            a4="Content effectiveness depends on audience behavior and industry trends. Blog posts and video content improve engagement. Downloadable resources further increase lead generation and brand authority."
            q5="How do you determine content topics?"
            a5="We conduct audience research and competitive analysis to identify high-impact topics. Our team prioritizes search intent and engagement potential. We also streamline content direction based on performance data."
            q6="How do you measure content marketing success?"
            a6="Content success is measured through organic traffic growth and lead conversions. We track <a href='https://richesmediadigital.com/blog/social-media-marketing-hacks-to-double-your-brand-engagement/'>audience engagement</a> and search rankings to refine ongoing content strategies."
          />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
